import AnimateIn from './AnimateIn';
import classNames from 'classnames';

const Quote = ({ className, component }) => (
  <AnimateIn className={classNames('quote', className)}>
    <blockquote>
      <div className="quote__body">{component.quote}</div>
      <footer className="quote__footer">{component.quotee}</footer>
    </blockquote>
  </AnimateIn>
);

export default Quote;

/*
import { useInView } from 'react-intersection-observer'
import classNames from 'classnames'

const Quote = ({
  className,
  component
}) => {
	const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true
  })
	return (
	  <div className={classNames('component', 'quote', className, {
        ['component--visible']: inView})}
	      ref={ref}
	  >
	    <blockquote>
	      <div className="quote__body">{ component.quote }</div>
	      <footer className="quote__footer">{ component.quotee }</footer>
	    </blockquote>
	  </div>
	)
}
export default Quote
*/
